import { Button, Col, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { APPLICATION_ID, FETCH_FILE_BYTES } from '../../../../shared/constants/commonConstants';
import { FetchFileByteRequest, FetchFileByteResponse } from '../../../../shared/models/file.profile.model';
import { DoctorDetails } from '../../../../shared/models/inventory.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, base64UrlEncode, extractSecondLevelBaseUrl } from '../../../../utils/utility';
import DoctorProfileForm from './DoctorProfileForm';
import { INVENTROY_CONSTANTS } from './../../../../shared/constants/commonConstants';
import { setSelectedDoctorsList } from '../../../../store/actions/inventoryAction';

const EditDoctorProfile = ({ match: { path, params: { id: doctorId } } }: any): ReactElement => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [submitAgain, setSubmitAgain] = useState(false);
  const id = base64UrlDecode(doctorId);
  const doctorsDetailList = useSelector(({ inventory: { doctorsList } }: any): DoctorDetails[] => doctorsList);
  const [doctorDetails, setDoctorDetails] = useState(null as any);
  const dispatch = useDispatch();
  useEffect((): void => {
    if (doctorsDetailList) {
      setDoctorDetails(doctorsDetailList.filter((v: DoctorDetails): boolean => {
        return +v.id === +id;
      })[0]);
    }
  }, [doctorsDetailList]);

  useEffect((): any => {
    if (doctorDetails) {
      dispatch(setSelectedDoctorsList(doctorDetails));
    }
  }, [doctorDetails]);

  useEffect((): void => {
    if (doctorDetails) {
      if (!doctorDetails?.imageUrl && doctorDetails?.personalDetail?.imageId) {
        const fileIdentifiers = [
          doctorDetails?.personalDetail?.imageId,
          doctorDetails?.professionalDetail?.doctorSignature,
        ]?.filter(Boolean);
        getFileBytes(fileIdentifiers);
      }
    }
  }, [doctorDetails]);

  const getFileBytes = async (imgIds: string[]): Promise<void> => {
    if (imgIds && imgIds?.length > 0) {
      const payload: FetchFileByteRequest = {
        applicationId: APPLICATION_ID,
        fileIdentifiers: imgIds,
      };
      const response: FetchFileByteResponse = await SendRequest.instance.post(`${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_FILE_BYTES}`, payload);
      if (response && response.isSuccess) {
        setDoctorDetails({ ...doctorDetails, imageUrl: response?.fileDetails?.[0].fileBytes });
      }
    }
  };

  const onSubmitClick = (): void => {
    if (isSubmit) {
      setSubmitAgain(true);
      setIsSubmit(false);
    } else {
      setIsSubmit(true);
      setSubmitAgain(false);
    }
  };

  return (
    <div>
      <PageHeader
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.doctorProfileRoute + base64UrlEncode(doctorDetails?.id)}
        pageTitle={INVENTROY_CONSTANTS.editDoctorProfileText}
        rightComponent={
          (): ReactElement => (
            <Row>
              <Col md={24}>
                <div className="text-right">
                  <Button className="btn-form-submit" type="link" onClick={onSubmitClick}> Save</Button></div>
              </Col>
            </Row>
          )
        }
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        {doctorDetails && (
          <DoctorProfileForm isSubmit={isSubmit} submitAgain={submitAgain} data={doctorDetails} />
        )}
      </div>
    </div>
  );
};

export default EditDoctorProfile;
